export default __webpack_public_path__ + "img/img5.994e7149.jpeg";